import React from 'react';
import { Button } from '@components';
import { Modal } from 'gd-design-library';

import styles from './MergedItemsModal.module.scss';
import classnames from 'classnames/bind';

const CN = 'merged-items-modal';
const bodyClassName = `${CN}__body`;

const cx = classnames.bind(styles);

interface MergedItemsProps {
    open: boolean;
    handleClose: () => void;
}

export const MergedItemsModal: React.FC<MergedItemsProps> = ({ open, handleClose }) => (
  <Modal isOpen={ open } onClose={ handleClose } title='Previous items added'>
    <div className={ cx(bodyClassName) }>
      You still have some items in your bag from a previous session, please review your order before continuing.
    </div>
    <Button onClick={ handleClose }>
      Continue shopping
    </Button>
  </Modal>
);
